import { render, staticRenderFns } from "./BaseStatItem.vue?vue&type=template&id=c8952a36&"
import script from "./BaseStatItem.vue?vue&type=script&lang=js&"
export * from "./BaseStatItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseStatItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports